import { API, ApiResponseBase, CustomAxiosError } from "../../../../../logics/api-config";
import { IDailyTrend } from "../../../../../utils/interfaces/Accounting/Recap/IDailyTrend";
import { useQuery, UseQueryResult } from "react-query";

export interface ApiResponse extends ApiResponseBase {
    data: IDailyTrend;
}

async function doGet(type: string, year: string, month: string): Promise<IDailyTrend> {
    const response = await API.get(`/accounting/recap/${type}/${year}/${month}/daily_trend`);
    // Se la risposta contiene una proprietà 'data' che è l'array, usiamo quella
    if (response?.data && !Array.isArray(response.data) && Array.isArray(response.data.data)) {
        return response.data.data;
    }
    return response?.data;
}

const useApiGetDailyTrend = (
    type: string,
    year: string,
    month: string,
    options: any = {}
): UseQueryResult<IDailyTrend, CustomAxiosError> => {
    return useQuery<IDailyTrend, CustomAxiosError>(
        ["getDailyTrend", type, year, month],
        () => doGet(type, year, month),
        { 
            enabled: !!type && !!year && !!month,
            ...options 
        }
    );
};

export default useApiGetDailyTrend;
